"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrentMileageModalComponent = void 0;
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
var CurrentMileageModalComponent = /** @class */ (function () {
    function CurrentMileageModalComponent(activeModal, formBuilder) {
        this.activeModal = activeModal;
        this.formBuilder = formBuilder;
        this.createForm();
    }
    CurrentMileageModalComponent.prototype.createForm = function () {
        this.CurrentMileageEditForm = this.formBuilder.group({
            currentmileage: '',
        });
    };
    CurrentMileageModalComponent.prototype.submitForm = function () {
        this.activeModal.close(this.CurrentMileageEditForm.value);
    };
    CurrentMileageModalComponent.prototype.ngOnInit = function () {
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], CurrentMileageModalComponent.prototype, "my_modal_title", void 0);
    CurrentMileageModalComponent = __decorate([
        core_1.Component({
            selector: 'app-currentmileagemodal',
            template: require('./currentmileagemodal.component.html')
        }),
        __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
            forms_1.FormBuilder])
    ], CurrentMileageModalComponent);
    return CurrentMileageModalComponent;
}());
exports.CurrentMileageModalComponent = CurrentMileageModalComponent;
